<app-header></app-header>
<div class="content">
  <div class="main-title dashboard-title">Regulamin</div>

  <div class="description"><span class="body">
    Usługa doładowania telefonu jest realizowana przez SupraSAT.<br/>

    SupraSAT odpowiada za realizację usługi zgodnie z Regulaminem.<br/>

    Regulamin doładowań telefonów komórkowych na portalu satphonerecharge.com oraz warunki przetwarzania danych osobowych przez SupraSAT.
  </span></div>
  <div class="description"><span class="body">
    Znam i akceptuję Regulamin doładowań telefonów komórkowych na portalu satphonerecharge.com oraz warunki
    przetwarzania danych osobowych przez SupraSAT.
  </span></div>
  <div class="description"><span class="body">
    Administratorem danych osobowych jest SupraSAT, ul. Malachitowa 70, 25-754 Kielce. NIP: 9590365019
  </span></div>
  <div class="description"><span class="body">
    Podanie danych osobowych jest dobrowolne, ale niezbędne do realizacji usługi.
    <br/>
    Podstawa prawna, cel, okres przetwarzania danych osobowych oraz uprawnienia przysługujące Użytkownikowi, a także inne ważne informacje dotyczące zasad przetwarzania danych
    osobowych są szczegółowo określone w Regulaminie doładowań telefonów komórkowych na platformie satphonerecharge.com.
  </span></div>
  <div class="description"><span class="body">
    Usługa doładowania telefonu jest realizowana przez SupraSAT
  </span></div>
  <div class="description"><span class="body">
    Aby zamówić fakturę za doładowanie napisz pod adres kontakt&#64;suprasat.pl lub zadzwoń pod numer +48 41 242 90 00.
  </span></div>
  <div class="description"><span class="body">
    Kontunuując potwierdzam, że znam i akceptuję Regulamin doładowań telefonów komórkowych na portalu
    satphonerecharge.com oraz chcę, aby usługa została zrealizowana od razu.
    <br/>
    Rozumiem, że po jej wykonaniu nie mogę odstąpić od umowy.
  </span>
    <footer class="content-footer">
      <img alt="logo" src="assets/parp-logo.jpg">
    </footer>
  </div>
</div>
